import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["envConfig"];
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import getDisplayName from "react-display-name";
import App from "next/app";
import { initialisePrivateEnvConfig, initialisePublicEnvConfig } from "../internal/store.js";
/**
 * Higher-order function that leverages `getInitialProps` to sync Environment Config between the server and client.
 * @param Comp
 *
 * @example ```tsx
 * // pages/_app.tsx
 * import React from "react";
 * import type { AppProps } from "next/app";
 * import { withEnvConfig } from "@catchoftheday/env-config";
 *
 * function App({ Component, pageProps }: AppProps) {
 * 	return <Component {...pageProps} />;
 * }
 *
 * export default withEnvConfig(App); // <-- Wrap your app with `withEnvConfig`
 * ```
 */

import { jsx as ___EmotionJSX } from "@emotion/react";
export function withEnvConfig(Comp) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$globalTarget = options.globalTarget,
      globalTarget = _options$globalTarget === void 0 ? globalThis : _options$globalTarget;

  var WithEnvConfig = function WithEnvConfig(_ref) {
    var envConfig = _ref.envConfig,
        props = _objectWithoutProperties(_ref, _excluded);

    // Conditional is here is purely to satisfy TS; Next.js will ensure the `envConfig` prop is always defined.
    // `initialiseEnvConfig` will throw if it is not.
    if (envConfig) {
      // This must be called before `App` is rendered to ensure the config is available.
      initialisePublicEnvConfig(envConfig, globalTarget);
    }

    return ___EmotionJSX(Comp, props);
  };

  WithEnvConfig.displayName = "withEnvConfig(".concat(getDisplayName(Comp), ")");

  WithEnvConfig.getInitialProps = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(appContext) {
      var _Comp$getInitialProps, _Comp$getInitialProps2;

      var envConfig, _yield$import$loadEnv, publicEnvConfig, privateEnvConfig, _yield$Promise$all, _yield$Promise$all2, appProps, compProps;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              envConfig = null; // Only run on the server

              if (!false) {
                _context.next = 10;
                break;
              }

              _context.next = 4;
              return import("../env-config.config.js");

            case 4:
              _yield$import$loadEnv = _context.sent.loadEnvConfig();
              publicEnvConfig = _yield$import$loadEnv.publicEnvConfig;
              privateEnvConfig = _yield$import$loadEnv.privateEnvConfig;
              // To ensure the config is available for downstream `getInitialProps` calls, we must initialise it here
              // (in addition to within the `WithEnvConfig` as `getInitialProps` is SSR-only).
              initialisePublicEnvConfig(publicEnvConfig, globalTarget);
              initialisePrivateEnvConfig(privateEnvConfig, globalTarget);
              envConfig = publicEnvConfig;

            case 10:
              _context.next = 12;
              return Promise.all([App.getInitialProps(appContext), (_Comp$getInitialProps = (_Comp$getInitialProps2 = Comp.getInitialProps) === null || _Comp$getInitialProps2 === void 0 ? void 0 : _Comp$getInitialProps2.call(Comp, appContext)) !== null && _Comp$getInitialProps !== void 0 ? _Comp$getInitialProps : {}]);

            case 12:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              appProps = _yield$Promise$all2[0];
              compProps = _yield$Promise$all2[1];
              return _context.abrupt("return", _objectSpread(_objectSpread(_objectSpread({}, appProps), compProps), {}, {
                envConfig: envConfig
              }));

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return WithEnvConfig;
}